import { Component, Input } from "@angular/core";
import { ReferenceMeasurementItemLengthComponent } from "@components/reference-measurement-item-length/reference-measurement-item-length.component";
import { AirPath } from "@domain/project/floorplan/air-path";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";

@Component({
  selector: "app-air-path-notes",
  imports: [FloorplanItemDetailsComponent, ReferenceMeasurementItemLengthComponent],
  templateUrl: "./air-path-notes.component.html",
  standalone: true,
})
export class AirPathNotesComponent {
  protected airPath!: AirPath;

  @Input({ required: true }) set floorplanItem(item: FloorplanItem) {
    this.airPath = item as AirPath;
  }
}
